export enum LoaderType {
  light = "light",
  dark = "dark"
}
